import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ResultsSection } from './components/ResultsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { PoweredBySection } from './components/PoweredBySection';
import { IncludedSection } from './components/IncludedSection';
import { DemosSection } from './components/DemosSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/SectionDivider';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { HowItWorksSection } from './components/HowItWorksSection';
function PageWrapper({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="pt-24 min-h-screen" data-id="element-0">
      {children}
      <SectionDivider data-id="element-1" />
      {/* Back to home CTA */}
      <div className="text-center py-12" data-id="element-2">
        <a href="/" onClick={e => {
        e.preventDefault();
        window.history.pushState({}, '', '/');
        window.dispatchEvent(new PopStateEvent('popstate'));
        window.scrollTo(0, 0);
      }} className="inline-flex items-center space-x-2 border border-[#c9a84c] text-[#c9a84c] hover:bg-[#c9a84c] hover:text-black px-6 py-3 rounded-lg font-medium transition-all duration-300" data-id="element-3">
          <span data-id="element-4">← Back to Home</span>
        </a>
      </div>
    </div>;
}
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, {
      threshold: 0.1
    });
    // Small delay to ensure DOM is ready after route change
    const timer = setTimeout(() => {
      const hiddenElements = document.querySelectorAll('.reveal');
      hiddenElements.forEach(el => observer.observe(el));
    }, 50);
    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [currentPath]);
  const renderPage = () => {
    switch (currentPath) {
      case '/results':
        return <PageWrapper title="Results" data-id="element-5">
            <ResultsSection data-id="element-6" />
          </PageWrapper>;
      case '/included':
        return <PageWrapper title="What You Get" data-id="element-7">
            <IncludedSection data-id="element-8" />
          </PageWrapper>;
      case '/demos':
        return <PageWrapper title="Demos" data-id="element-9">
            <DemosSection data-id="element-10" />
          </PageWrapper>;
      case '/pricing':
        return <PageWrapper title="Pricing" data-id="element-11">
            <PricingSection data-id="element-12" />
          </PageWrapper>;
      case '/faq':
        return <PageWrapper title="FAQ" data-id="element-13">
            <FaqSection data-id="element-14" />
          </PageWrapper>;
      case '/contact':
        return <PageWrapper title="Contact" data-id="element-15">
            <ContactSection data-id="element-16" />
          </PageWrapper>;
      case '/how-it-works':
        return <PageWrapper title="How It Works" data-id="element-17">
            <HowItWorksSection data-id="element-18" />
          </PageWrapper>;
      case '/privacy':
        return <PageWrapper title="Privacy Policy" data-id="element-19">
            <PrivacyPolicy data-id="element-20" />
          </PageWrapper>;
      case '/terms':
        return <PageWrapper title="Terms of Service" data-id="element-21">
            <TermsOfService data-id="element-22" />
          </PageWrapper>;
      default:
        // Home — full landing page
        return <>
            <HeroSection data-id="element-23" />
            <ResultsSection data-id="element-24" />
            <BenefitsSection data-id="element-25" />
            <HowItWorksSection data-id="element-26" />
            <ComparisonSection data-id="element-27" />
            <PoweredBySection data-id="element-28" />
            <IncludedSection data-id="element-29" />
            <DemosSection data-id="element-30" />
            <PricingSection data-id="element-31" />
            <FaqSection data-id="element-32" />
            <ContactSection data-id="element-33" />
          </>;
    }
  };
  return <div className="min-h-screen font-sans selection:bg-[#c9a84c]/30" style={{
    backgroundColor: '#050505',
    color: '#f5f5f5'
  }} data-id="element-34">
      <div className="noise-overlay" data-id="element-35"></div>
      <Header data-id="element-36" />
      <main data-id="element-37">{renderPage()}</main>
      <Footer data-id="element-38" />
    </div>;
}